import { useQuery } from "@tanstack/react-query";
import { supabase } from "./supabase";
import { rpc, type RespostaWms } from "./rpc";
import { chamarFuncao, type RespostaFuncao } from "./funcoes";

export const URL_FUNCOES = `${(import.meta.env.VITE_SUPABASE_URL as string | undefined)?.replace(/\/$/, "") ?? ""}/functions/v1`;

/** Situação real da conexão com o Tiny (wms_tiny_conexao_situacao, migration 53). */
export interface ConexaoTiny {
  situacao: "conectado" | "atencao" | "desconectado";
  codigo: "OK" | "SEM_CREDENCIAIS" | "NUNCA_CONECTADO" | "RECUSADO" | "VENCIDO" | "ERRO_TEMPORARIO" | "VENCE_LOGO"
    | "LIMITE_DO_TINY" | "ROTINA_PARADA";
  mensagem: string;
  desde?: string | null;
  renovado_em?: string | null;
  verificado_em?: string | null;
  expira_em?: string | null;
  refresh_expira_em?: string | null;
  erro?: string | null;
}

export const TOM_CONEXAO = { conectado: "ok", atencao: "alerta", desconectado: "erro" } as const;
export const TEXTO_CONEXAO = { conectado: "Conectado", atencao: "Atenção", desconectado: "Desconectado" } as const;

/** Situações em que o admin resolve clicando em Reconectar (entrar de novo no Tiny). */
export function pedeReconectar(c: ConexaoTiny | null | undefined): boolean {
  return !!c && ["NUNCA_CONECTADO", "RECUSADO", "VENCIDO", "LIMITE_DO_TINY", "VENCE_LOGO"].includes(c.codigo);
}

/** Situação da conexão (líder ou admin), relida a cada minuto. */
export function useConexaoTiny(ativo = true) {
  return useQuery({
    queryKey: ["tiny", "conexao"],
    queryFn: () => rpc<RespostaWms>("wms_tiny_conexao").then((r) => r as unknown as ConexaoTiny),
    enabled: ativo,
    refetchInterval: 60_000,
  });
}

/** Abre o login do Tiny (admin). A volta cai na tela Integração. */
export async function conectarTiny(): Promise<void> {
  const { data, error } = await supabase.rpc("wms_tiny_oauth_iniciar", { p_url_retorno: window.location.origin });
  if (error || !data) throw new Error(error?.message ?? "Não foi possível iniciar a conexão");
  window.location.href = `${URL_FUNCOES}/tiny-oauth?state=${data}`;
}

/** Botão Testar agora (admin): renova o acesso na hora e devolve a situação. */
export async function testarConexaoTiny(): Promise<ConexaoTiny | null> {
  const r = await chamarFuncao<RespostaFuncao & { situacao?: ConexaoTiny | null }>("tiny-oauth", { testar: true });
  return r.situacao ?? null;
}
